import React from "react";
import { useNavigate } from "react-router-dom";
import ScoutAvatar from "../scout-request/ScoutAvatar";

// Agent Radar — single-player chat card (radar_player_share attachment, P3).
// Anatomy verbatim from the prototype (TP Agent Radar.dc.html player chat card
// ~L303-319): 296px card, avatar + name + meta (pos · age · nat), club row with
// crest, white "View profile" button with blue text → /search/player/{ws_id}.
// Personal tool: NO attribution pill (unlike ScoutRecommendationForwardCard).
//
// Metadata is read tolerantly (nested `player` OR flat) so a small BE field-name
// drift never blanks the card; the CTA target is ws_player id (public profile pk =
// WSPlayer id) with an explicit `cta_path` override honoured if the BE sends one.
const RadarPlayerShareCard = (props) => {
  const navigate = useNavigate();
  const meta = props.attachments?.[0]?.metadata || {};
  const p = meta.player || meta;

  const name = p.name || p.player_name || "Player";
  const clubName = p.club_name || p.club || "";
  const crest = p.club_logo_url || p.club_crest || p.club_logo || "";
  const photo = p.player_image_url || p.image_url || p.photo || "";
  const wsId = meta.ws_player_id ?? p.ws_player_id ?? meta.player_id ?? p.player_id;
  const ctaPath = meta.cta_path || (wsId != null ? `/search/player/${wsId}` : null);

  // Every citizenship in the text line (L-FE-1); the radar payload carries names, not blocks.
  const nationalityText = Array.isArray(p.nationalities) && p.nationalities.length ? p.nationalities.filter(Boolean).join(" / ") : p.nationality;
  const line = [p.position, p.age, nationalityText]
    .filter((v) => v !== null && v !== undefined && v !== "")
    .join(" · ");

  return (
    <div className="w-[296px] bg-white border border-[#E4E9F0] rounded-[14px] shadow-[0_1px_3px_rgba(0,0,0,0.06)] p-[13px]">
      <div className="flex items-center gap-2.5">
        {photo ? (
          <img
            src={photo}
            alt=""
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : (
          <ScoutAvatar name={name} size={40} />
        )}
        <div className="flex-1 min-w-0">
          <div className="text-[13.5px] font-bold text-[#111827] truncate">{name}</div>
          {line && <div className="text-[11.5px] text-[#6B7280] mt-px truncate">{line}</div>}
        </div>
      </div>

      {clubName && (
        <div className="flex items-center gap-1.5 mt-[9px]">
          {crest ? (
            <img src={crest} alt="" className="w-4 h-4 rounded-sm object-contain flex-shrink-0" />
          ) : null}
          <div className="text-[12px] text-[#374151] font-semibold truncate">{clubName}</div>
        </div>
      )}

      {ctaPath && (
        <button
          type="button"
          onClick={() => navigate(ctaPath)}
          className="w-full mt-[11px] bg-white border border-[#DDE3EB] rounded-[9px] py-[7px] text-[12.5px] font-semibold text-[#2283FF] hover:bg-[#F5F9FF] cursor-pointer"
        >
          View profile
        </button>
      )}
    </div>
  );
};

export default RadarPlayerShareCard;
